import styled from 'styled-components'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp32};
`

export const IframeContainer = styled.div`
  height: 85vh;

  iframe {
    border: none;
    height: 100%;
    width: 100%;
  }
`
